import { Component, inject } from '@angular/core';
import { GamePlay } from 'src/app/model/game-play';
import { GameService } from 'src/app/services/game.service';
import { TranslocoModule } from '@ngneat/transloco';

@Component({
    selector: 'app-last-play-section',
    templateUrl: './last-play-section.component.html',
    styleUrls: ['./last-play-section.component.scss'],
    imports: [TranslocoModule]
})
export class LastPlaySectionComponent {

  lastGamePlay: GamePlay | null

  rusher?:number
  passer?:number
  receiver?:number
  tackler1?:number
  tackler2?:number
  battedDown?:number
  forcedFumbleBy?:number
  returner?:number
  kicker?:number
  recoveredBy?:number
  interceptedBy?:number
  
  constructor () {
    const game = inject(GameService);


    try {
      this.lastGamePlay = game.getPrecedingGamePlay(game.getFirstPendingGamePlay())
    } catch { // No preceding gameplay.
      this.lastGamePlay = null;
    }

    if (this.lastGamePlay != null) {
      this.rusher = this.lastGamePlay.rusher ?? this.lastGamePlay.oppRusher
      this.passer = this.lastGamePlay.passer ?? this.lastGamePlay.oppPasser
      this.receiver = this.lastGamePlay.receiver ?? this.lastGamePlay.oppReceiver
      this.tackler1 = this.lastGamePlay.tackler1 ?? this.lastGamePlay.oppTackler1
      this.tackler2 = this.lastGamePlay.tackler2 ?? this.lastGamePlay.oppTackler2
      this.battedDown = this.lastGamePlay.battedDown ?? this.lastGamePlay.oppBattedDown
      this.forcedFumbleBy = this.lastGamePlay.forcedFumbleBy ?? this.lastGamePlay.oppForcedFumbleBy
      this.returner = this.lastGamePlay.returner ?? this.lastGamePlay.oppReturner
      this.kicker = this.lastGamePlay.kicker ?? this.lastGamePlay.oppKicker
      this.recoveredBy = this.lastGamePlay.recoveredBy ?? this.lastGamePlay.oppRecoveredBy
      this.interceptedBy = this.lastGamePlay.interceptedBy ?? this.lastGamePlay.oppInterceptedBy
    }
  }
}
